import React from 'react';

interface State {}

const UsersRegisterPage = () => {
  return <>진행x</>;
};

export default UsersRegisterPage;
